import { Toolbar, Typography } from '@mui/material';
import React from 'react';
import { bool, string, element } from 'prop-types';

const styles = {
  root: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  title: {
    fontWeight: 600,
  },
};

const SectionTitle = ({ children = null, title, disableGutters = false }) => (
  <Toolbar sx={styles.root} disableGutters={disableGutters}>
    <Typography component="div" sx={styles.title} variant="h6">
      {title}
    </Typography>
    {children}
  </Toolbar>
);

SectionTitle.propTypes = {
  title: string.isRequired,
  children: element,
  disableGutters: bool,
};

export default SectionTitle;
